export enum MobileAppOS {
  android = 1
}
